export class CustomHeaders {
    static readonly ResponseTime: string = 'X-Response-Time-Milliseconds';
    static readonly Authorization: string = 'Authorization';
    static readonly RefreshToken: string = 'Refresh-Token';
    static readonly TokenExpired: string = 'Token-Expired';
    static readonly InvalidTimestamp: string = 'Invalid-Timestamp';
    static readonly RedirectUrl: string = 'Redirect-Url';
}
